import { IState } from 'reducers'
import { UserState } from './user.reducer'

export const getUserSelector = (state: IState): UserState => state.user
